import { SnackbarProvider } from 'notistack'
import React from 'react'

const Provider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>
}

export default React.memo(Provider)
